import { render, staticRenderFns } from "./AnoFiscalPeriodosOrcamento.vue?vue&type=template&id=8dbb9354&lang=html&"
import script from "./AnoFiscalPeriodosOrcamento.vue?vue&type=script&lang=js&"
export * from "./AnoFiscalPeriodosOrcamento.vue?vue&type=script&lang=js&"
import style0 from "./AnoFiscalPeriodosOrcamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/ano-fiscal/AnoFiscalPeriodosOrcamento.vue
// module id = 1053
// module chunks = 28